export const fontsTgicoV2 = [
  {
    style: "normal",
    urlSet: [
      {
        format: "truetype",
        url: "/fonts/tgico_v2.ttf",
      },
    ],
    weight: "normal",
  },
];
